import React, { useEffect, useState } from 'react';
import { Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { reportingOp } from 'store/ducks/Reportings';
import { RootState } from 'store/configureStore';
import { set_isDisplayed } from 'store/ducks/Reportings/reportingSlice';
import {
  BProps,
  ICTRiskFunctionServiceDetails,
} from 'store/ducks/Reportings/types';
import { columnsIctRisksFunctionServiceDetails } from 'constants/reportColumns';

const RiskExposureServiceDetails: React.FC<BProps> = ({ entityName }) => {
  const { is_displayed, date } = useSelector(
    (state: RootState) => state.reportings,
  );
  const [data, setData] = useState<ICTRiskFunctionServiceDetails[]>([]);
  const dispatch = useDispatch();

  const fetchData = async () => {
    dispatch(set_isDisplayed(false));

    if (!entityName) return;

    const entityIds = entityName.split(',').map((id) => id.trim());

    try {
      const fetchedData = await reportingOp.getICTRiskExposureService(
        entityIds[0],
        date,
      );
      if (fetchedData && fetchedData.ict_risks) {
        const formattedData: ICTRiskFunctionServiceDetails[] =
          fetchedData.ict_risks.map((risk: any) => ({
            entity_id: fetchedData.entity_id,
            entity_name: risk.entity_name ?? '',
            entity_start_date: risk.entity_start_date ?? '',
            entity_end_date: risk.entity_end_date ?? '',
            entity_reporting_date: risk.entity_reporting_date ?? '',
            dependency_type_description: risk.dependency_type_description ?? '',
            dependency_type_name: risk.dependency_type_name ?? '',
            exposure_category_description:
              risk.exposure_category_description ?? '',
            exposure_category_name: risk.exposure_category_name ?? '',
            ict_risk_name: risk.risk_name ?? '',
            ict_system_end_date: risk.ict_system_end_date ?? '',
            ict_system_name: risk.ict_system_name ?? '',
            ict_system_start_date: risk.ict_system_start_date ?? '',
            risk_exposure_description: risk.risk_exposure_description ?? '',
            risk_exposure_end_date: risk.risk_exposure_end_date ?? '',
            risk_exposure_name: risk.risk_exposure_name ?? '',
            risk_exposure_start_date: risk.risk_exposure_start_date ?? '',
            risk_start_date: risk.risk_start_date ?? '',
            risk_source_name: risk.risk_source_name ?? '',
            risk_level_name: risk.risk_level_name ?? '',
            risk_end_date: risk.risk_end_date ?? '',
            risk_description: risk.risk_description ?? '',
            risk_deleted: risk.risk_deleted ?? '',
            ict_system_category_name: risk.ict_system_category_name ?? '',
            function_start_date: risk.function_start_date ?? '',
            function_name: risk.function_name ?? '',
            function_end_date: risk.function_end_date ?? '',
          }));

        setData(formattedData);
      } else {
        setData([]);
      }
    } catch (error) {
      console.error('Error fetching ict risk source:', error);
      setData([]);
    }
  };

  useEffect(() => {
    fetchData();
  }, [is_displayed, entityName]);

  return (
    <Table
      columns={columnsIctRisksFunctionServiceDetails}
      dataSource={data.map((item, idx) => ({ ...item, key: idx }))}
      scroll={{ x: 1000, y: 430 }}
    />
  );
};

export default RiskExposureServiceDetails;
